import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import browserHistory from '../../../../common/browserHistory';
import { SelectInput } from '../../../../public/components/Input';
import { setActiveEquityAction } from '../../../../common/action-creators/domainData';
import {
    tickerDetailListSelector,
    equityActiveTickerSelector,
} from '../../../../common/selectors/domainData';
import styles from './styles.scss';


const propTypes = {
    className: PropTypes.string,
    tickerDetailList: PropTypes.arrayOf(
        PropTypes.shape({
        }),
    ).isRequired,
    setActiveEquity: PropTypes.func.isRequired,
    activeTicker: PropTypes.string,
};

const defaultProps = {
    className: '',
    activeTicker: undefined,
};

const mapStateToProps = state => ({
    tickerDetailList: tickerDetailListSelector(state),
    activeTicker: equityActiveTickerSelector(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    setActiveEquity: params => (dispatch(setActiveEquityAction(params))),
});

@connect(mapStateToProps, mapDispatchToProps)
@CSSModules(styles, { allowMultiple: true })
export default class EquitySearch extends React.PureComponent {
    static defaultProps = defaultProps;
    static propTypes = propTypes;

    constructor(props) {
        super(props);

        this.state = {
            selectedTicker: props.activeTicker,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedTicker: nextProps.activeTicker,
        });
    }

    keySelector = ticker => ticker.ticker

    labelSelector = ticker => `[${ticker.ticker}] ${ticker.fullName || ''}`

    handleTickerSelectChange = (value) => {
        this.setState({
            selectedTicker: value,
        });

        this.props.setActiveEquity({
            ticker: value,
        });

        // TODO: use redirect
        browserHistory.push(`/equity/${value}`);
    }

    render() {
        const {
            className,
            tickerDetailList,
        } = this.props;

        const { selectedTicker } = this.state;

        return (
            <div className={className}>
                <SelectInput
                    placeholder="Search Ticker"
                    styleName="select-input"
                    showHintAndError={false}
                    hideClearButton
                    options={tickerDetailList}
                    keySelector={this.keySelector}
                    labelSelector={this.labelSelector}
                    value={selectedTicker}
                    onChange={this.handleTickerSelectChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/topic/Equity/components/EquitySearch/index.js